import { PolymerElement } from '@polymer/polymer/polymer-element.js';
import { html } from '@polymer/polymer/lib/utils/html-tag.js';
function handleResponse(token) {
  return new Promise((resolve, reject) => {
    try {
      this._handleResponse(token);
      resolve();
    } catch(err) {
      reject(err);
    }
  });
}

class Recaptcha extends PolymerElement {
  static get template() {
    return html`
    <style>
      @font-face {
        font-family: 'Noto Sans';
        src: url('fonts/NotoSans-Italic.eot');
        src: url('fonts/NotoSans-Italic.eot?#iefix') format('embedded-opentype'),
          url('fonts/NotoSans-Italic.woff') format('woff'),
          url('fonts/NotoSans-Italic.ttf') format('truetype');
        font-weight: normal;
        font-style: italic;
      }

      @font-face {
        font-family: 'Noto Sans';
        src: url('fonts/NotoSans-Bold.eot');
        src: url('fonts/NotoSans-Bold.eot?#iefix') format('embedded-opentype'),
          url('fonts/NotoSans-Bold.woff') format('woff'),
          url('fonts/NotoSans-Bold.ttf') format('truetype');
        font-weight: bold;
        font-style: normal;
      }

      @font-face {
        font-family: 'Noto Sans';
        src: url('fonts/NotoSans-BoldItalic.eot');
        src: url('fonts/NotoSans-BoldItalic.eot?#iefix') format('embedded-opentype'),
          url('fonts/NotoSans-BoldItalic.woff') format('woff'),
          url('fonts/NotoSans-BoldItalic.ttf') format('truetype');
        font-weight: bold;
        font-style: italic;
      }

      @font-face {
        font-family: 'Noto Sans';
        src: url('fonts/NotoSans.eot');
        src: url('fonts/NotoSans.eot?#iefix') format('embedded-opentype'),
          url('fonts/NotoSans.woff') format('woff'),
          url('fonts/NotoSans.ttf') format('truetype');
        font-weight: normal;
        font-style: normal;
      }
      :host {
        display: block;
      }
    </style>
    <div hidden\$="{{hideBadge}}" class="g-recaptcha" data-sitekey\$="{{recaptchaKey}}" data-size="invisible" data-badge\$="{{badgePosition}}" data-type\$="{{recaptchaType}}" data-tabindex\$="{{tabindex}}">
    </div>
`;
  }

  static get is() { return "invisible-recaptcha"; }
  static get properties() {
    return  {
      recaptchaKey: {
        type: String,
        notify: true
      },
      lastResponse: {
        type: String,
        notify: true
      },
      badgePosition: {
        type: String,
        value: 'bottomright'
      },
      hideBadge: {
        type: Boolean,
        value: false
      },
      shadowDom: {
        type: Boolean,
        value: false
      },
      recaptchaType: {
        type: String,
        value: 'image'
      },
      tabindex: {
        type: Number,
        value: 0
      },
    }
  }

  constructor() {
    super()
  }

  verify() {
    grecaptcha.execute();
  }

  reset() {
    grecaptcha.reset();
  }

  getResponse() {
    return lastResponse
  }

  render(container) {
    const recaptcha = document.querySelector('div.invisible-recaptcha');
    if (recaptcha) {
      grecaptcha.reset();
      recaptcha.remove();
    }
    this.shadowHelper = document.createElement('div');
    this.shadowHelper.classList.add('invisible-recaptcha');
    document.querySelector('body').appendChild(this.shadowHelper);
    if (this.hideBadge) {
      this.shadowHelper.hidden = true;
    }
    var renderOption = {
      "sitekey": this.recaptchaKey,
      "theme": "light",
      'size': 'invisible',
      'callback': handleResponse.bind(this),
      'badge': this.badgePosition,
      'tabindex': this.tabindex,
      'type': this.recaptchaType
    };
    grecaptcha.render(this.shadowHelper, renderOption);
  }

  _handleResponse() {
    var token = grecaptcha.getResponse();
    this.lastResponse = token;
    const event = new CustomEvent('verification-finished', {token, bubbles: true, composed: true});
    this.dispatchEvent(event);
    grecaptcha.reset();
  }
}
customElements.define(Recaptcha.is, Recaptcha);
